<template>
  <div id="app">
    <v-snackbar v-model="$store.state.shell.snackBar.display" color="purple">
      {{ $store.state.shell.snackBar.text }}
      <v-btn
        text
        icon
        color="indigo"
        @click="$store.dispatch('shell/hideSnackbar')"
      >
        <v-icon v-text="$getIcon('mdiCloseCircleOutline')"></v-icon>
      </v-btn>
    </v-snackbar>
    <component
      v-if="mountApp"
      :is="layouts[layoutStore.layoutName]"
      v-bind="layoutStore.props"
    >
      <router-view></router-view>
    </component>
    <span v-else class="font-weight-medium">Please wait...</span>
    <template v-if="$store.state.auth.check_session_iframe">
      <iframe
        id="op_iframe"
        width="0"
        height="0"
        :src="$store.state.auth.check_session_iframe"
      ></iframe>
      <iframe
        id="rp_iframe"
        width="0"
        height="0"
        src="/check_session_iframe.html"
      ></iframe>
    </template>
  </div>
</template>

<script>
export default {
  OIDCStatuses: {
    OP_IN__RP_OUT: "op:loggedIn-rp:loggedOut",
    OP_IN__RP_IN__BAD: "op:loggedIn-rp:loggedIn-bad",
    OP_OUT__RP_IN: "op:loggedOut-rp:loggedIn",
    OP_OUT__RP_OUT: "op:loggedOut-rp:loggedOut"
  },
  data() {
    return {
      layouts: this.$rhrCoreShellOptions.layouts
    };
  },
  computed: {
    mountApp() {
      if (this.$auth.options.autoLoginOIDCStrategy) {
        return (
          this.$store.state.auth.loggedIn ||
          !!this.$store.state.auth.OPSessionCheckedOnce ||
          this.$options.OIDCStatuses.OP_OUT__RP_OUT ===
            this.$store.state.auth.OIDCStatus
        );
      }
      return true;
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
